import React from "react";
import PropTypes from "proptypes";
import "./Hero.scss";

const Hero = ({ title }) => (
  <div className="row">
    <div className="hero-nicaragua-picture">
      <div className="hero-thailand-frisket">
        <div className="hero-title-container">
          <div className="col-md-12">
            <h1 className="hero-title">{title}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Hero.propTypes = {
  title: PropTypes.string.isRequired
};

export default Hero;
